import { render, staticRenderFns } from "./OtaMessages.vue?vue&type=template&id=a8da9ac2&scoped=true"
import script from "./OtaMessages.vue?vue&type=script&lang=js"
export * from "./OtaMessages.vue?vue&type=script&lang=js"
import style0 from "./OtaMessages.vue?vue&type=style&index=0&id=a8da9ac2&prod&scoped=true&lang=css"
import style1 from "./OtaMessages.vue?vue&type=style&index=1&id=a8da9ac2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8da9ac2",
  null
  
)

export default component.exports